import { render, staticRenderFns } from "./grouprevisi.vue?vue&type=template&id=22bc3d7a"
import script from "./grouprevisi.vue?vue&type=script&lang=js"
export * from "./grouprevisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports